export default [
  'netInvestmentIncome',
  'otherIncome',
  'realEstateIncome',
  'salary',
];



// WEBPACK FOOTER //
// ./src/vuex/modules/profile/resources/finances/incomeKeys.js